import React, { Component } from 'react';
import {
  Container, TextField, Button, Box, Typography, CircularProgress,
  Collapse, IconButton, Alert
} from '@mui/material';
import { NavLink } from 'react-router-dom';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import CloseIcon from '@mui/icons-material/Close';
//import axios from 'axios';
import JoditEditor from 'jodit-react';
import Serverurl from './Apiurl';
import axiosInstance from "./axiosConfig";
export default class AddBlog extends Component {
  editor = React.createRef();
  state = {
    bl_title: '',
    bl_description: '',
    bl_image: [],
    previewImage: [],protectedImages: {},
    errors: {},
    loading: false,
    submitText: 'Submit',existingImages: [], 
    alertOpen: false,
    alertMessage: '',
    alertSeverity: 'error',
  };
  componentDidMount() {
    const id = new URLSearchParams(window.location.search).get('id');
    if (id) this.fetchBlog(id);
  }
fetchBlog = (id) => {
  this.setState({ loading: true });

  axiosInstance
    .get(`${Serverurl}blog/bloggetbyid/${id}`)
    .then(res => {
      const { blog } = res.data;

      const images = blog.bl_image
        ? (Array.isArray(blog.bl_image)
            ? blog.bl_image
            : [blog.bl_image])
        : [];

      this.setState({
        bl_title: blog.bl_title,
        bl_description: blog.bl_description,
        existingImages: images,
        bl_image: [],
        previewImage: [],
        loading: false,
      });

      images.forEach(image => {
        this.loadProtectedImage(image);
      });
    })
    .catch(() => this.showAlert('Failed to fetch blog.'));
};
  showAlert = (message, severity = 'error') => {
    this.setState({ alertOpen: true, alertMessage: message, alertSeverity: severity });
  }
  loadProtectedImage = async (filename) => {
  if (!filename || this.state.protectedImages[filename]) {
    return;
  }

  try {
    const response = await axiosInstance.get(
      `${Serverurl}api/files/${filename}`,
      {
        responseType: 'blob',
      }
    );

    const imageUrl = URL.createObjectURL(response.data);

    this.setState(prevState => ({
      protectedImages: {
        ...prevState.protectedImages,
        [filename]: imageUrl,
      },
    }));
  } catch (error) {
    console.error('Failed to load image:', filename, error);
  }
};
  closeAlert = () => {
    this.setState({ alertOpen: false, alertMessage: '' });
  }
validate = () => {
  const { bl_title, bl_description, bl_image, previewImage } = this.state;
  let tempErrors = {};
  const cleanedDescription = bl_description.replace(/<[^>]*>/g, '').trim();
  if (!bl_title.trim()) tempErrors.bl_title = 'Title is required';
  if (!cleanedDescription) tempErrors.bl_description = 'Description is required';
if (this.state.existingImages.length === 0 && this.state.bl_image.length === 0) {
  tempErrors.bl_image = 'At least one image is required';
}
  if (Object.keys(tempErrors).length > 0) {
    this.setState({ errors: tempErrors });
    this.showAlert(Object.values(tempErrors)[0]);
    return false;
  }
  this.setState({ errors: {} });
  this.closeAlert();
  return true;
}
handleImageChange = (e) => {
  const files = Array.from(e.target.files);
  const allowedTypes = ['image/jpeg', 'image/png', 'image/jpg'];
  const maxSize = 700 * 1024;
  let errorMessage = '';
  files.forEach(file => {
    if (!allowedTypes.includes(file.type)) errorMessage = 'Only JPG/PNG images are allowed';
    if (file.size > maxSize) errorMessage = 'Each image must be less than 700KB';
  });
  if (errorMessage) {
    this.showAlert(errorMessage, 'warning');
    return;
  }
  this.state.previewImage.forEach(URL.revokeObjectURL);
  const newBlImages = [...this.state.bl_image, ...files];
  const newPreviews = [...this.state.previewImage, ...files.map(f => URL.createObjectURL(f))];
  this.setState({
    bl_image: newBlImages,
    previewImage: newPreviews,
  });
};
handleSubmit = () => {
  if (!this.validate()) return;
  const id = new URLSearchParams(window.location.search).get('id');
  const formData = new FormData();
  formData.append("bl_title", this.state.bl_title);
  formData.append("bl_description", this.state.bl_description);
  formData.append("bl_publishdate", new Date());
  // Send existing image filenames (from URLs)
this.state.existingImages.forEach(filename => {
  formData.append("existing_images", filename);
});
  // Send new files
  this.state.bl_image.forEach(file => {
    formData.append("bl_image", file);
  });
  let request;
  if (id) {
    request = axiosInstance.put(`${Serverurl}blog/blogupdate/${id}`, formData, { headers: { "Content-Type": "multipart/form-data" }});
  } else {
    request = axiosInstance.post(Serverurl+"blog/bloginsert", formData, { headers: { "Content-Type": "multipart/form-data" }});
  }
  request.then(() => {
    window.location.href = "/BlogManagement";
  }).catch(err => {
    this.setState({
      alertMessage: err.response?.data?.message || "Error saving blog.",
      alertSeverity: "error",
      alertOpen: true,
    });
  });
};
  handleExplainChange = (newValue) => {
    this.setState({
      bl_description: newValue, 
    });
  };
  handleRemoveImage = (index) => {
  URL.revokeObjectURL(this.state.previewImage[index]);
  const newBlImages = [...this.state.bl_image];
  const newPreviewImages = [...this.state.previewImage];
  newBlImages.splice(index, 1);
  newPreviewImages.splice(index, 1);
  this.setState({
    bl_image: newBlImages,
    previewImage: newPreviewImages
  });
}
handleRemoveExistingImage = (index) => {
  const newExistingImages = [...this.state.existingImages];
  newExistingImages.splice(index, 1);
  this.setState({ existingImages: newExistingImages });
}
  render() {
    const isEditing = !!new URLSearchParams(window.location.search).get('id');
    return (
		      <div className="maincontentDiv">
      <Container>
        <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 2 }}>
          <NavLink to="/BlogManagement">
            <Button
style={{
    marginTop: '15px'
}}
size="small"
			variant="contained" className="frmPrimarybtn" startIcon={<ArrowBackIcon />}>
              Back
            </Button>
          </NavLink>
        </Box>
        <Collapse in={this.state.alertOpen}>
          <Alert severity={this.state.alertSeverity}
            action={<IconButton size="small" onClick={this.closeAlert}><CloseIcon /></IconButton>}
            sx={{ mb: 2 }}>
            {this.state.alertMessage}
          </Alert>
        </Collapse>
        <Typography sx={{textAlign:'center'}} className="contentHeading" variant="h5" gutterBottom>
          {isEditing ? 'Blog' : 'Blog'}
        </Typography>
        <p>Title<span className="validation"> * </span></p>
        <TextField
		size="small"
          fullWidth
          value={this.state.bl_title}
          onChange={(e) => this.setState({ bl_title: e.target.value })}
          margin="normal"
        />
        <p>Description<span className="validation"> * </span></p>
        <JoditEditor
          ref={this.editor}
          value={this.state.bl_description}
           tabIndex={2}
  onChange={this.handleExplainChange}
        />
        <Box sx={{ mt: 2, mb: 2 }}>
<input type="file" 
id="blog-img" 
accept="image/*"
 multiple 
hidden 
onChange={this.handleImageChange} />
          <label htmlFor="blog-img">
            <Button
size="small"
			variant="contained" component="span" className="frmPrimarybtn" disabled={this.state.loading}>
              Upload Image
            </Button>
          </label>
        </Box>
{this.state.existingImages.map((src, index) => (
  <Box key={`existing-${index}`} sx={{ position: 'relative', display: 'inline-block', mr: 1, mt:2, mb:2 }}>
    <IconButton
      size="small"
      onClick={() => this.handleRemoveExistingImage(index)}
      sx={{ position: 'absolute', top: 0, right: 0, bgcolor: 'rgba(255,255,255,0.7)', '&:hover': { bgcolor: 'rgba(255,255,255,0.9)' } }}
      aria-label="remove existing image"
    >
      <CloseIcon fontSize="small" />
    </IconButton>
    <img src={this.state.protectedImages[src]} alt={`existing-${index}`} style={{ width: 150, height: 100, objectFit: 'contain', borderRadius: 4 }} />
  </Box>
))}
{this.state.previewImage.map((src, index) => (
  <Box key={`new-${index}`} sx={{ position: 'relative', display: 'inline-block', mr: 1, mt: 2, mb: 2 }}>
    <IconButton
      size="small"
      onClick={() => this.handleRemoveImage(index)}
      sx={{ position: 'absolute', top: 0, right: 0, bgcolor: 'rgba(255,255,255,0.7)', '&:hover': { bgcolor: 'rgba(255,255,255,0.9)' } }}
      aria-label="remove new image"
    >
      <CloseIcon fontSize="small" />
    </IconButton>
    <img src={src} alt={`new-${index}`} style={{ width: 150, height: 100, objectFit: 'contain', borderRadius: 4 }} />
  </Box>
))}
        {/* Submit */}
        <Box sx={{ textAlign:'right' ,pb:3,mt: 3 }}>
          <Button variant="contained" className="frmPrimarybtn"
		  size="small"
            onClick={this.handleSubmit}
            disabled={this.state.loading}>
            {this.state.submitText}
          </Button>
          {this.state.loading && (
            <CircularProgress size={24} sx={{ ml: 2, position: 'relative', top: '6px' }} />
          )}
        </Box>
      </Container></div>
    );
  }
}